<template>
  <div v-if="show">
    <ModalIconBanner
      :title="$t('哈囉，{name}！', {name: nickname})"
      icon="icon-Hint-active"
      :is-show="step === 'noPlay'"
    >
      <div class="px-3 py-4 text-center next-step-banner">
        <h4>{{ $t('歡迎你的加入，現在就來跟嘉嘉老師下一盤吧！') }}</h4>

        <b-button class="mt-3" variant="primary" size="md" @click="goToPlay">
          {{ $t('出發') }}
        </b-button>
        <a class="link-action mt-2" @click="close(true)">
          {{ $t('之後再說') }}
        </a>
      </div>
    </ModalIconBanner>
    <ModalIconBanner
      :title="$t('取得你的第一個棋力！')"
      icon="icon-Hint-active"
      :is-show="step === 'hasPlay'"
    >
      <div class="px-3 py-4 text-center next-step-banner">
        <h4>{{ $t('歡迎你的加入，來做個棋力測驗吧？') }}</h4>

        <b-button class="mt-3" variant="primary" size="md" @click="goToTest">
          {{ $t('前往測驗') }}
        </b-button>
        <a class="link-action mt-2" @click="pass">
          {{ $t('下次再測') }}
        </a>
      </div>
    </ModalIconBanner>
    <ModalConfirm
      v-model="isPass"
      :confirm-text="$t('知道了')"
      hide-cancel
      @confirm="close"
    >
      <h4 style="white-space: pre-line">
        {{ $t('之後可以在「個人」\n完成初始棋力測驗') }}
      </h4>
    </ModalConfirm>
  </div>
</template>

<script>
import ModalIconBanner from '@/components/Modal/ModalIconBanner.vue';
import ModalConfirm from '@/components/Modal/ModalConfirm.vue';
import userServices from '@/services/user';

export default {
  components: {
    ModalConfirm,
    ModalIconBanner,
  },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    // 由 ModalBasicInfo 收集到的「有/沒有學過圍棋」結果，必為 'hasPlay' 或 'noPlay'。
    initialSelected: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isPass: false,
      step: null,
    };
  },
  watch: {
    show() {
      this.applyInitialSelected();
    },
    initialSelected() {
      this.applyInitialSelected();
    },
  },
  computed: {
    userData() {
      return this.$store.getters['user/userData'];
    },
    nickname() {
      return this.userData?.nickName;
    },
  },
  methods: {
    applyInitialSelected() {
      // 條件齊備才設 step：show=true 且有 initialSelected。
      // show 與 initialSelected 兩個 watcher 任一觸發都會跑這裡，
      // 不依賴觸發順序，timing race 自然解決。
      if (!this.show) return;
      if (!this.initialSelected) return;
      if (this.step === 'hasPlay' || this.step === 'noPlay') return;
      userServices.finishRankTestQuestion();
      this.step = this.initialSelected === 'noPlay' ? 'noPlay' : 'hasPlay';
    },
    goToPlay() {
      this.close(true);
      // 導到棋魂對決，並自動開啟「小嘉嘉－G19」角色 modal
      // - series=HEIJIAJIA 自動展開該分類的 collapse
      // - opponentName + rank 用來在 NpcList 內配對開啟 modal
      //   （避免硬編 npcId，因 id 可能跨環境不同）
      this.$router.push({
        path: '/play/npc-list',
        query: {series: 'HEIJIAJIA', opponentName: '小嘉嘉', rank: 1},
      });
    },
    goToTest() {
      this.close();
      this.$router.push({name: 'rank-test'});
    },
    pass() {
      this.step = '';
      this.isPass = true;
    },
    close(noTest = false) {
      if (noTest) {
        userServices.finishRankTestQuestion({isDone: true});
      }
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
:deep() .modal-dialog {
  width: 300px;
  height: 300px;
  margin: 0 auto;
  color: $font-grayscale-1;
  .modal-body {
    padding: 0;
  }
}
:deep() .btn.btn-md {
  min-width: 140px;
}

.header {
  padding: 14px 8px 14px 16px;
  border-bottom: 1px solid $line-1;
}
img {
  width: 300px;
}
.btn-wrap {
  border-top: 1px solid #ced4da;
  text-align: center;
}

// 「之後再說」「下次再測」文字連結樣式（與設計稿一致）
.next-step-banner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;

  .link-action {
    display: inline-block;
    font-size: 16px;
    line-height: 28px;
    color: $primary;
    cursor: pointer;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
